<template>
	<div style="margin: 16px;">
		<p>更新日期：2021年8月27日</p>
		<p>生效日期：2021年8月24日</p>
		<p>欢迎您选择由深圳乐漂科技有限公司（以下简称“我们”、“乐漂科技”）提供的产品或服务，本政策向您说明您在使用我们的产品或服务时我们收集、使用、存储和共享个人信息的情况，以及您所享有的相关权利等事宜。</p>
		<p>如果您有任何疑问、意见或建议，请通过以下联系方式与我们联系：</p>
		<p>电子邮件：dev@motone.cc</p>
		<p>电 话：</p>
		<p>本政策将帮助您了解以下内容：</p>
		<p>1.我们如何收集和使用您的个人信息</p>
		<p>2.我们如何使用Cookie和同类技术</p>
		<p>3.我们如何共享、转让、公开披露您的个人信息</p>
		<p>4.我们如何保护您的个人信息</p>
		<p>5.您的权利</p>
		<p>6.我们如何处理未成年人的个人信息</p>
		<p>7.您的个人信息如何在全球范围转移</p>
		<p>8.本隐私政策如何更新</p>
		<p>9.如何联系我们</p>
		<p>乐漂科技深知个人信息对您的重要性，并会尽全力保护您的个人信息安全可靠。我们致力于维持您对我们的信任，恪守以下原则，保护您的个人信息：权责一致原则、目的明确原则、选择同意原则、最少够用原则、确保安全原则、主体参与原则、公开透明原则等。同时，乐漂科技承诺，我们将按业界成熟的安全标准，采取相应的安全保护措施来保护您的个人信息。
		</p>
		<p>请在使用我们的产品（或服务）前，仔细阅读并了解本《隐私政策》。</p>
		<p>一、我们如何收集和使用您的个人信息</p>
		<p>(一) 我们如何收集您的信息</p>
		<p>我们会出于本政策所述的以下目的，收集和使用您的个人信息：</p>
		<p>1.注册成为乐漂科技产品或服务的用户</p>
		<p>您需要向我们提供您的手机号码，用于用户登录。</p>
		<p>2.向您提供产品或服务</p>
		<p>1)您向我们提供的信息</p>
		<p>A. 在您使用“导航”功能时，您需要向我们授权“定位”、“位置信息”权限。在您授权后，我们会读取到您的精准位置信息和经纬度，会根据您的需要使用的功能提供导航服务。</p>
		<p>B.
			在您使用“电话”功能时，您需要向我们授权“电话”、“联系人”和“通话记录”权限。在您授权后并使用“电话”功能时，我们会读取到您的通讯记录并呈现在手机应用内，同时我们会上传至服务器，提供给“语音助手”，您可通过“语音助手”进行控制拨号。我们保证不会泄露个人通讯录给第三方，仅作用户个人使用。
		</p>
		<p>C. 在您使用“本地音乐”功能时，您需要向我们授权“存储与读写”或“多媒体”权限，以便我们读取本地音乐，让您在驾驶过程中可听个人的歌曲。</p>
		<p>您使用本软件中的信息发布、即时通讯等服务时，应当向我们提供真实身份信息，否则我们将不得为您提供相关服务。服务使用过程中，您可以对我们的产品及服务的体验问题反馈，帮助我们更好地了解您使用我们产品或服务的体验和需求，改善我们产品或服务。
		</p>
		<p>2)我们在您使用服务过程中收集的信息</p>
		<p>我们会收集关于您使用产品、服务以及使用方式的信息并将这些信息进行关联以提升我们的服务，这些信息包括：</p>
		<p>A.设备信息：我们会根据您在软件安装及使用中授予的具体权限，接收并记录您所使用的设备相关信息（例如设备型号、操作系统版本、设备设置、唯一设备标识符等软硬件特征信息）、设备所在位置相关信息（例如IP地址、MAC地址、GPS位置信息以及能够提供相关信息的Wi-Fi接入点、蓝牙和基站等传感器信息）。
		</p>
		<p>B.日志信息：当您使用我们的网站或客户端提供的产品或服务时，我们会收集您对我们服务的详细使用情况，作为有关网络日志保存。例如您的搜索查询内容、软件列表、MAC地址、使用的语言、访问日期和时间、您的访问记录、从应用内产生的通话状态等。
		</p>
		<p>请注意，单独的设备信息、日志信息等是无法识别特定自然人身份的信息。如果我们将这类非个人信息与其他信息结合用于识别特定自然人身份，或者将其与个人信息结合使用，则在结合使用期间，这类非个人信息将被视为个人信息，除取得您授权或法律法规另有规定外，我们会将该类个人信息做匿名化、去标识化处理。
		</p>
		<p>C.当您与我们联系时，我们可能会保存您在应用内产生的通信/通话记录和内容或您留下的联系方式等信息，以便与您联系或帮助您解决问题，或记录相关问题的处理方案及结果。</p>
		<p>D.当您在使用本产品服务执行某些操作时（例如向您的分组添加好友），我们可能会向您或其他人发送通知；对于您在本服务开放平台开通使用的第三方应用服务，我们将在您启动该应用时收集相关信息，并按照本隐私权政策进行处理。</p>
		<p>E.
			当您在使用本软件集成的第三方SDK时，第三方可能依据提供该功能所必须要求您提供相应的个人信息。在使用该功能之前，请您务必仔细阅读该第三方的《隐私政策》。如果您不同意，可以选择停止使用该功能。目前，本软件集成的SDK有友盟+统计分析、天地图、QQ音乐。
		</p>
		<p>SDK名称 SDK服务类型 收集个人信息字段 SDK服务商数据安全能力 SDK隐私政策链接</p>
		<p>友盟+统计分析SDK 为APP提供系统分析服务及基础反作弊服务 设备MAC地址、唯一设备识别码（IMEI/android ID/IDFA/OPENUDID/GUID\SIM卡IMSI信息）、用于反作弊的地理位置信息
			公安部三级等保认证（非银机构最高安全等级）；ISO27001信息安全管理体系认证；ISO27018公有云个人信息保护体系认证。 https://www.umeng.com/page/policy</p>
		<p>天地图 为APP提供导航功能 GPS位置信息 / https://www.tianditu.gov.cn/</p>
		<p>QQ音乐 同步QQ 音乐APP 列表，并不涉及用户隐私信息。 用户的QQ音乐账号记录。 信息安全管理体系认证；信息技术服务管理体系认证；质量管理体系认证（ISO9000）。
			https://y.qq.com/m/client/intro/privacy.html</p>
		<p>3.为您提供安全保障</p>
		<p>为预防、发现、调查欺诈、侵权、危害安全、非法或违反我们的协议、政策或规则的行为，我们可能收集或整合您的用户信息、服务使用信息、设备信息、日志信息以及取得您授权或依据法律共享的信息。</p>
		<p>4.其他用途</p>
		<p>我们将基于本政策未载明的其他特定目的收集您的信息时，会事先征求您的同意。</p>
		<p>如我们停止运营我们的产品或服务，我们将停止继续收集您个人信息的活动，并将停止运营的通知以逐一送达或公告的形式通知您，对所持有的个人信息进行删除或匿名化处理。</p>
		<p>(二) 我们如何使用您的信息</p>
		<p>收集您的信息是为了向您提供服务及提升服务质量，为了实现这一目的，我们会把您的信息用于下列用途：</p>
		<p>1.向您提供您使用的本产品或服务，并维护、改进、优化这些服务及服务体验。</p>
		<p>2.为预防、发现、调查欺诈、侵权、危害安全、非法或违反我们的协议、政策或规则的行为，保护您、其他用户或公众、我们的合法权益，我们可能使用或整合您的用户信息、服务使用信息、设备信息、日志信息以及我们取得您授权或依据法律共享的信息，来综合检测及防范安全事件，并依法采取必要的记录、审计、分析、处置措施。
		</p>
		<p>3.经您许可的其他用途。</p>
		<p>二、我们如何使用 Cookie 和同类技术</p>
		<p>我们提供的产品或服务，没有使用Cookie和同类技术。</p>
		<p>三、我们如何共享、转让、公开披露您的信息</p>
		<p>(一) 共享</p>
		<p>我们不会与我们的服务提供者以外的公司、组织和个人共享您的个人信息，但以下情况除外：</p>
		<p>1.在获取明确同意的情况下共享：获得您的明确同意后，我们会与其他方共享您的个人信息。</p>
		<p>2.在法定情形下的共享：我们可能会根据法律法规规定、诉讼争议解决需要，或按行政、司法机关依法提出的要求，对外共享您的个人信息。</p>
		<p>3.在您被他人投诉侵犯知识产权或其他合法权利时，需要向投诉人披露您的必要资料，以便进行投诉处理的。</p>
		<p>4.与授权合作伙伴共享：仅为实现本隐私政策中声明的目的，我们的某些服务将由我们和授权合作伙伴共同提供。我们可能会与合作伙伴共享您的某些个人信息，以提供更好的客户服务和用户体验。为了更好的服务客户，我们的产品可能会集成第三方的SDK或其他类似的应用程序，例如【天地图】SDK，为了您的信息安全，我们已与第三方SDK服务商签署严格数据安全保密协议，这些公司会严格遵守我们的数据隐私和安全要求。除非得到您的同意，我们不会与其共享您的个人身份信息。为便于您更好地了解【天地图】采集的数据类型及用途，以及如何保护您的个人信息，您可以登录
			https://www.tianditu.gov.cn/ 了解【天地图】相关服务条款及隐私政策。</p>
		<p>除法律另有规定外，我们对其他网站的隐私保护措施不负任何责任。我们可能在任何需要的时候增加商业伙伴或共用品牌的网站，但是提供给他们的将仅是去标识化的信息，我们将不会公开您的身份。</p>
		<p>(二) 转让</p>
		<p>我们不会将您的个人信息转让给任何公司、组织和个人，但以下情况除外：</p>
		<p>1.在获取明确同意的情况下转让：获得您的明确同意后，我们会向其他方转让您的个人信息。</p>
		<p>2.在我们发生合并、收购或破产清算情形，或其他涉及合并、收购或破产清算情形时，如涉及到个人信息转让，我们会要求新的持有您个人信息的公司、组织继续受本政策的约束，否则我们将要求该公司、组织和个人重新向您征求授权同意。
		</p>
		<p>(三) 公开披露</p>
		<p>我们仅会在以下情况下，公开披露您的个人信息：</p>
		<p>1.获得您明确同意后；</p>
		<p>2.如果我们确定您出现违反法律法规或严重违反本服务或产品相关协议规则的情况，或为保护乐漂科技或公众的人身财产安全免遭侵害，我们可能依据法律法规或本服务或产品相关协议规则征得您同意的情况下披露关于您的个人信息，包括相关违规行为以及乐漂科技已对您采取的措施。
		</p>
		<p>(四) 共享、转让、公开披露个人信息时事先征得授权同意的例外</p>
		<p>以下情形中，共享、转让、公开披露您的个人信息无需事先征得您的授权同意：</p>
		<p>1.与国家安全、国防安全有关的；</p>
		<p>2.与公共安全、公共卫生、重大公共利益有关的；</p>
		<p>3.与犯罪侦查、起诉、审判和判决执行等有关的；</p>
		<p>4.出于维护您或其他个人的生命、财产等重大合法权益但又很难得到本人同意的；</p>
		<p>5.您自行向社会公众公开的个人信息；</p>
		<p>6.从合法公开披露的信息中收集个人信息的，如合法的新闻报道、政府信息公开等渠道；</p>
		<p>7.法律法规规定的其他情形。</p>
		<p>根据法律规定，共享、转让经去标识化处理的个人信息，且确保数据接收方无法复原并重新识别个人信息主体的，不属于个人信息的对外共享、转让及公开披露行为，对此类数据的保存及处理将无需另行向您通知并征得您的同意。</p>
		<p>四、我们如何保护您的信息</p>
		<p>(一)保存期限</p>
		<p>您在使用我们的产品及服务期间，我们将持续为您保存您的个人信息。如果您注销帐户或主动删除上述信息，我们将依据网络安全法等法律法规规定保存您的信息。在您注销帐户或主动删除上述信息后，我们不会再对您的个人信息进行商业化使用，但我们可能会对您的个人信息进行匿名化处理后使用。
		</p>
		<p>(二)保存地域</p>
		<p>您的个人信息均储存于中华人民共和国境内。如部分产品或服务涉及跨境，我们需要向境外传输您的个人信息，我们会严格按照法律法规的规定执行，并保证您的个人信息安全。</p>
		<p>(三)安全措施</p>
		<p>1.我们会采取各种预防措施来保护您的个人信息，防止您的个人信息遭到未经授权访问、公开披露、使用、修改、损坏或丢失。我们会使用加密技术确保数据的保密性；我们会使用受信赖的保护机制防止数据遭到恶意攻击；我们会部署访问控制机制，确保只有授权人员才可访问个人信息。我们会加强员工对于保护个人信息重要性的认识。
		</p>
		<p>2. 目前，我们已经取得了以下认证：ISO20000认证，ISO27001认证，ISO9000认证，CMMI3认证。</p>
		<p>3.我们会采取合理可行的措施，尽力避免收集无关的个人信息。我们只会在达成本政策所述目的所需的期限内保留您的个人信息，除非需要延长保留期限或受到法律的允许。</p>
		<p>(四)互联网环境并非百分之百安全，尽管我们有这些安全措施，但请注意在互联网上不存在“完善的安全措施”，我们将尽力确保您的信息的安全性。</p>
		<p>1.互联网并非绝对安全的环境，而且电子邮件、即时通讯并未加密，我们强烈建议您不要通过此类方式发送个人信息。请使用复杂密码，协助我们保证您的账号安全。</p>
		<p>2.在不幸发生个人信息安全事件后，我们将按照法律法规的要求，及时向您告知：安全事件的基本情况和可能的影响、我们已采取或将要采取的处置措施、您可自主防范和降低风险的建议、对您的补救措施等。我们将及时将事件相关情况以邮件、信函、电话、推送通知等方式告知您，难以逐一告知个人信息主体时，我们会采取合理、有效的方式发布公告。
		</p>
		<p>同时，我们还将按照监管部门要求，主动上报个人信息安全事件的处置情况。</p>
		<p>五、您的权利</p>
		<p>按照中国相关的法律、法规、标准，以及其他国家、地区的通行做法，我们保障您对自己的个人信息行使以下权利：</p>
		<p>（一）访问您的个人信息</p>
		<p>您有权访问您的个人信息，法律法规规定的例外情况除外。</p>
		<p>（二）更正您的个人信息</p>
		<p>当您发现我们处理的关于您的个人信息有错误时，您有权要求我们做出更正。您可以通过电话或电子邮件的方式通知我们。我们将在十五个工作日内回复您的更正请求。为保障安全，我们将在您行使更正信息权之前，对您的身份信息进行验证。
		</p>
		<p>（三）删除您的个人信息</p>
		<p>在以下情形中，您可以向我们提出删除个人信息的请求：</p>
		<p>1、如果我们处理个人信息的行为违反法律法规；</p>
		<p>2、如果我们收集、使用您的个人信息，却未征得您的同意；</p>
		<p>3、如果我们处理个人信息的行为违反了与您的约定；</p>
		<p>4、如果您不再使用我们的产品或服务，或您注销了账号；</p>
		<p>5、如果我们不再为您提供产品或服务。</p>
		<p>若我们决定响应您的删除请求，我们还将同时通知从我们获得您的个人信息的实体，要求其及时删除，除非法律法规另有规定，或这些实体获得您的独立授权。</p>
		<p>当您从我们的服务中删除信息后，我们可能不会立即在备份系统中删除相应的信息，但会在备份更新时删除这些信息或将这些信息进行匿名化处理。</p>
		<p>（四）改变您授权同意的范围</p>
		<p>每个业务功能需要一些基本的个人信息才能得以完成。对于额外个人信息的收集和使用，您可以随时给予或收回您的授权同意。</p>
		<p>当您收回同意后，我们将不再处理相应的个人信息。但您收回同意的决定，不会影响此前基于您的授权而开展的个人信息处理。</p>
		<p>（五）约束信息系统自动决策</p>
		<p>在某些业务功能中，我们可能仅依据信息系统、算法等在内的非人工自动决策机制做出决定。如果这些决定显著影响您的合法权益，您有权要求我们做出解释，我们也将提供适当的救济方式。</p>
		<p>（六）响应您的上述请求</p>
		<p>为保障安全，您可能需要提供书面请求，或以其他方式证明您的身份。我们可能会先要求您验证自己的身份，然后再处理您的请求。我们将在十五个工作日内做出答复。</p>
		<p>对于您合理的请求，我们原则上不收取费用，但对多次重复、超出合理限度的请求，我们将视情收取一定成本费用。对于那些无端重复、需要过多技术手段（例如，需要开发新系统或从根本上改变现行惯例）、给他人合法权益带来风险或者非常不切实际（例如，涉及备份磁带上存放的信息）的请求，我们可能会予以拒绝。
		</p>
		<p>在以下情形中，按照法律法规要求，我们将无法响应您的请求：</p>
		<p>1、与国家安全、国防安全直接相关的；</p>
		<p>2、与公共安全、公共卫生、重大公共利益直接相关的；</p>
		<p>3、与犯罪侦查、起诉、审判和判决执行等直接相关的；</p>
		<p>4、有充分证据表明您存在主观恶意或滥用权利的；</p>
		<p>5、响应您的请求将导致您或其他个人、组织的合法权益受到严重损害的；</p>
		<p>6、涉及商业秘密的。</p>
		<p>六、未成年人保护</p>
		<p>我们的产品、网站和服务主要面向成人。如果没有父母或监护人的同意，未成年人不得创建自己的用户账户。</p>
		<p>尽管当地法律和习俗对未成年人的定义不同，但我们将不满 18 周岁的任何人均视为未成年人。</p>
		<p>如果我们发现自己在未事先获得可证实的父母同意的情况下收集了未成年人的个人信息，则会设法尽快删除相关数据。</p>
		<p>七、您的个人信息如何在全球范围转移</p>
		<p>原则上，我们在中华人民共和国境内收集和产生的个人信息，将存储在中华人民共和国境内。</p>
		<p>由于我们通过遍布全球的资源和服务器提供产品或服务，这意味着，在获得您的授权同意后，您的个人信息可能会被转移到您使用产品或服务所在国家/地区的境外管辖区，或者受到来自这些管辖区的访问。</p>
		<p>此类管辖区可能设有不同的数据保护法，甚至未设立相关法律。在此类情况下，我们会确保您的个人信息得到在中华人民共和国境内足够同等的保护。例如，我们会请求您对跨境转移个人信息的同意，或者在跨境数据转移之前实施数据去标识化等安全举措。
		</p>
		<p>八、本政策如何更新</p>
		<p>我们的隐私政策可能变更。</p>
		<p>未经您明确同意，我们不会削减您按照本隐私政策所应享有的权利。我们会在本页面上发布对本政策所做的任何变更。</p>
		<p>对于重大变更，我们还会提供更为显著的通知（包括对于某些服务，我们会通过电子邮件发送通知，说明隐私政策的具体变更内容）。</p>
		<p>本政策所指的重大变更包括但不限于：</p>
		<p>1、我们的服务模式发生重大变化。如处理个人信息的目的、处理的个人信息类型、个人信息的使用方式等；</p>
		<p>2、我们在所有权结构、组织架构等方面发生重大变化。如业务调整、破产并购等引起的所有者变更等；</p>
		<p>3、个人信息共享、转让或公开披露的主要对象发生变化；</p>
		<p>4、您参与个人信息处理方面的权利及其行使方式发生重大变化；</p>
		<p>5、我们负责处理个人信息安全的责任部门、联络方式及投诉渠道发生变化时；</p>
		<p>6、个人信息安全影响评估报告表明存在高风险时。</p>
		<p>九、如何联系我们</p>
		<p>如果您对本隐私政策有任何疑问、意见或建议，以及需要进行投诉举报的，通过以下方式与我们联系：</p>
		<p>电子邮件：dev@ledrift.net </p>
		<p>电 话：</p>
		<p>一般情况下，我们将在十五个工作日内回复。</p>
		<p>如果您对我们的回复不满意，特别是我们的个人信息处理行为损害了您的合法权益，您还可以通过以下外部途径寻求解决方案：向深圳市南山区有管辖权的法院提起诉讼来寻求解决方案。</p>
	</div>
</template>
<script>
	import {
		useI18n
	} from "vue-i18n";
	import {
		useStore
	} from "vuex";

	export default {
		mounted() {
			// var lang = this.$route.query.lang;
			// if(lang != null){
			//     const store = useStore();
			//     const i18n = useI18n();
			//     i18n.locale.value = lang;
			//     store.commit("setLanguage", lang);
			// }
			document.title = this.$t('msg.privacyPolicy')
		}
	}
</script>
<style>
	p {
		text-indent: 2em;
	}
</style>